<template>
  <div
    class="batch-packaging-select"
    :class="{
      'batch-packaging-select-all-checked': allChecked
    }"
  >
    <checkable-button
      v-for="(packaging, index) in packagingList"
      :key="packaging.id"
      v-model="packaging.value"
      class="batch-packaging-select-button"
      :class="{
        'batch-packaging-select-button-checked': packaging.value
      }"
      @change="handleChange(index)"
      @input="handleInput"
    >
      <md-icon
        :md-src="packaging.iconSrc"
        :class="['batch-packaging-select-icon', packaging.colorClass]"
      />

      <div class="batch-packaging-select-label">
        {{ packaging.name }}
      </div>
    </checkable-button>
  </div>
</template>

<script>
import CheckableButton from '@/components/common/CheckableButton.vue'
import strings from '@/strings'

const packagingList = strings.packagingStatus.filter(({ active }) => active).map(({ id, name, state, color }) => ({
  id,
  name,
  iconSrc: `/static/images/icon-${state}.svg`,
  colorClass: color,
  value: false
}))

export default {
  name: 'BatchPackagingSelect',
  components: {
    CheckableButton
  },
  props: {
    value: {
      type: Array,
      default: () => packagingList.map(({ id }) => id)
    }
  },
  data() {
    return {
      packagingList: packagingList.map(packaging => ({
        ...packaging,
        value: this.value.includes(packaging.id)
      }))
    }
  },
  computed: {
    allChecked() {
      return this.checkedPackaging.length === this.packagingList.length;
    },
    checkedPackaging() {
      return this.packagingList.filter(({ value }) => value).map(({ id }) => id);
    }
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.packagingList.forEach(packaging => {
          packaging.value = value.includes(packaging.id);
        });
      }
    }
  },
  methods: {
    handleChange(index) {
      if (this.allChecked) {
        this.$nextTick(() => {
          this.packagingList.forEach((packaging, i) => {
            packaging.value = i === index;
          });

          this.$forceUpdate()
        });
      }
    },
    handleInput() {
      this.$nextTick(() => {
        this.$emit('input', this.checkedPackaging);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.batch-packaging-select {
  display: flex;
  gap: 1rem;

  &-button {
    display: flex;
    gap: 0.625rem;
    align-items: center;
    opacity: 0.4;
    transition: opacity 0.3s ease-in-out;
  }

  &-button-checked {
    opacity: 1;
  }

  &-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.875rem;
    height: 1.875rem;
    border-radius: 100%;
    padding: 0.375rem;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.5);
  }

  &-button:hover &-icon {
    scale: 1.1;
  }

  &-label {
    font-size: 12px;
    color: $label-color;
    font-weight: 400;
    transition: color 0.2s ease-in-out;
  }

  &-button:hover &-label {
    color: darken($label-color, 10%);
  }

  &-button:active &-label {
    color: $label-color;
  }

  &-all-checked:hover &-button {
    opacity: 0.65;
  }

  &-all-checked &-button:hover {
    opacity: 1;
  }

  &-all-checked:not(:hover) &-button {
    opacity: 1;
  }
}
</style>
